<template>
	<div class="page">
		<nav-bar :home="true">
			<template v-slot:icon>
				<svg t="1710924534610" class="return" viewBox="0 0 1024 1024" version="1.1">
					<path
						d="M640 896h192V469.376h42.666667V896.213333c0 23.466667-19.029333 42.474667-42.666667 42.474667H597.333333V725.333333h-170.666666v213.333334H192c-23.573333 0-42.666667-18.986667-42.666667-42.453334V469.354667h42.666667V896h192V682.666667h256v213.333333z"
						fill="#ffffff"
					/>
					<path
						d="M100.032 506.133333a21.333333 21.333333 0 1 1-29.397333-30.933333L466.282667 99.349333a66.688 66.688 0 0 1 91.434666 0L953.386667 475.2a21.333333 21.333333 0 1 1-29.397334 30.933333L528.341333 130.282667a24.021333 24.021333 0 0 0-32.682666 0L100.053333 506.133333zM832 192h-128a21.333333 21.333333 0 0 1 0-42.666667h149.333333a21.333333 21.333333 0 0 1 21.333334 21.333334v149.333333a21.333333 21.333333 0 0 1-42.666667 0V192z"
						fill="#ffffff"
					/>
				</svg>
			</template>
		</nav-bar>
		<div class="bannerBox" v-if="banner?.length > 0">
			<van-swipe ref="banner" class="banner" :autoplay="3000" :show-indicators="false" @change="">
				<van-swipe-item v-for="(item, index) in banner" :key="index">
					<!-- <div class="item image"></div> -->
					<div class="item video">
						<!-- <img src="@/assets/images/mask.png" class="mask" /> -->
						<!-- <img src="@/assets/images/play.png" class="play" /> -->
						<img :src="item" class="cover" />
					</div>
				</van-swipe-item>
			</van-swipe>
			<div class="option" v-if="banner?.length > 1">
				<img src="@/assets/images/arrow-left.png" class="left icon" @click.stop="prev" />
				<img src="@/assets/images/arrow-right.png" class="right icon" @click.stop="next" />
			</div>
		</div>
		<div class="main">
			<van-skeleton title :row="8" :loading="loading" style="margin-top: 30px; padding: 0">
				<div class="coverBox">
					<img :src="details?.content_path" />
					<div class="name" v-text="details?.title"></div>
				</div>
				<div v-if="details?.sentence" class="content" v-html="details?.sentence"></div>
				<div v-if="details?.video_path?.url" class="video" @click.stop="play">
					<img :src="details?.cover_path || `${details?.video_path?.url}?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto`" class="cover" />
					<img src="@/assets/images/play.png" class="play" @click.stop="play" />
				</div>
				<!-- <div class="btn" @click.stop="goWeb">
					<span>我要咨询</span>
					<svg class="moreIcon">
						<path
							fill-rule="evenodd"
							fill="#ffffff"
							d="M0.661,4.890 L4.746,0.972 C4.871,0.835 5.123,0.835 5.248,0.972 L9.333,4.890 C9.396,4.973 9.521,5.000 9.616,5.000 C9.961,5.000 10.118,4.644 9.898,4.425 L5.500,0.205 C5.217,-0.069 4.746,-0.069 4.494,0.205 L0.095,4.425 C-0.124,4.644 0.064,5.000 0.378,5.000 C0.504,5.000 0.598,4.973 0.661,4.890 L0.661,4.890 Z"
						/>
					</svg>
				</div> -->
			</van-skeleton>
		</div>
		<div class="pdf" :class="{ show: details?.banner_color }" @click.stop="goPdf">
			<img v-if="details?.banner_color" :src="details?.banner_color" />
		</div>

		<!--悬浮按钮-->
		<!-- <drag-view>
			<div class="float-button" @click.stop="goWeb">
				<img src="@/assets/images/edit.png" />
				<div>
					填问卷
					<p></p>
					得积分
				</div>
			</div>
		</drag-view> -->
		<float-btn :slotState="true">
			<div class="float-button">
				<div class="button" v-for="(item, index) in actions" :key="index" @click.stop="selectOption(item, index)" v-text="item?.name"></div>
			</div>
		</float-btn>

		<van-action-sheet v-model="option" :actions="actions" cancel-text="取消" close-on-click-action @select="selectOption" @cancel="option = false" />
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import DragView from '@/components/DragView.vue';
import FloatBtn from '@/components/FloatBtnH5.vue';
import { Swipe, SwipeItem, Skeleton, Toast, ActionSheet } from 'vant';
export default {
	components: {
		NavBar,
		FloatBtn,
		DragView,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[Skeleton.name]: Skeleton
	},
	data() {
		return {
			loading: true,
			banner: [],
			details: {},
			option: false,
			actions: [
				{ name: '语音咨询', url: `tel:+864008101315` },
				{ name: '表单咨询', url: `https://go.schneider-electric.cn/zh/work/support/customer-care/contact-sales.jsp` }
			]
		};
	},
	created() {},
	mounted() {
		this.initShare();
		this.$dataStatistics({ event_type: 'view', page_title: '详情' }, ``);

		this.getDetails();
	},
	methods: {
		getDetails() {
			this.loading = true;
			this.$http.get(`/platform/product/${this.$route.query?.id}`).then((res) => {
				this.details = res?.data;
				this.banner = this.details?.banner || [];

				this.$nextTick(() => {
					this.loading = false;
				});
			});
		},
		prev() {
			if (!this.$refs.banner) return;
			this.$refs.banner.prev();
		},
		next() {
			if (!this.$refs.banner) return;
			this.$refs.banner.next();
		},
		goWeb() {
			this.option = true;
			let data = { name: this.details?.title, id: this.details?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `详情-我要咨询` }, `${JSON.stringify(data)}`);
		},
		play() {
			let data = { id: this.details?.id, name: this.details?.name, url: this.details?.video_path?.url };
			this.$dataStatistics({ event_type: 'click', page_title: `点击顶部视频` }, `${JSON.stringify(data)}`);
			this.$router.push({ path: `/video`, query: { video: encodeURIComponent(this.details?.video_path?.url) } });
		},
		goPdf() {
			let url = this.details?.pdf_url?.url;
			if (!url) return;
			let data = { name: this.details?.title, id: this.details?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `详情-预览彩页` }, `${JSON.stringify(data)}`);
			this.$router.push({ path: `/pdf`, query: { pdfUrl: encodeURIComponent(url), id: this.details?.id } });
		},
		selectOption(item, index) {
			console.log(item, index);
			if (!item?.url) return;
			let data = { name: this.details?.title, id: this.details?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `详情-${item?.name}` }, `${JSON.stringify(data)}`);

			this.$nextTick(() => {
				window.location.href = item?.url;
			});
		}
	}
};
</script>
<style lang="less" scoped>
.page {
	background: #fafafa;

	.bannerBox {
		width: 828px;
		height: 466px;
		display: block;
		position: relative;
		overflow: hidden;

		& .banner {
			width: 828px;
			height: 466px;
			display: block;

			& .item {
				width: 100%;
				height: 100%;

				&.video {
					position: relative;

					.mask {
						position: absolute;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						z-index: 1;
						display: block;
					}

					.play {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 162px;
						height: 162px;
						display: block;
						z-index: 11;
					}

					.cover {
						width: 100%;
						height: 100%;
						display: block;
					}
				}
			}
		}

		& .option {
			& .icon {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 41px;
				height: 54px;
				display: block;
				z-index: 11;

				&.left {
					left: 20px;
				}

				&.right {
					right: 20px;
				}
			}
		}
	}

	.main {
		padding: 0 36px;

		& > .coverBox {
			// margin-top: -60px;
			margin-top: calc(466px * 0.2 * -1);
			// height: 460px;
			padding: 60px 0;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			background-color: #fff;
			border-radius: @border-radius;
			box-shadow: @box-shadow;
			overflow: hidden;
			transform: rotate(0);
			box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.03);
			border: 1.5px solid #f2f2f2;
			margin-bottom: 40px;

			img {
				min-width: 450px;
				max-width: 90%;
				// height: 250px;
				height: auto;
				display: block;
			}

			.name {
				font-weight: 400;
				font-size: 30px;
				color: #000000;
				line-height: 1.5;
				padding: 0 30px;
				margin-top: 20px;
				text-align: center;
			}
		}

		& > .content {
			padding: 30px;
			padding-top: 50px;
			text-align: center;
			white-space: pre-wrap;
			background-color: #fff;
			border-radius: @border-radius;
			box-shadow: @box-shadow;
			overflow: hidden;
			transform: rotate(0);
			box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.03);
			border: 1.5px solid #f2f2f2;
			margin-bottom: 40px;
			font-size: 28px;
			line-height: 1.5;
			position: relative;

			&::before {
				content: '产品价值点';
				font-size: 26px;
				color: #fff;
				line-height: 1;
				font-weight: bold;
				display: block;
				margin-bottom: 20px;
				position: absolute;
				left: 0;
				top: 0;
				background-color: @themeColor;
				padding: 10px;
			}
		}

		& > .video {
			background-color: #fff;
			border-radius: @border-radius;
			box-shadow: @box-shadow;
			overflow: hidden;
			position: relative;
			height: 460px;
			margin-bottom: 50px;

			& .cover {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
				background-color: #000;
			}

			& .play {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: 162px;
				height: 162px;
				display: block;
				z-index: 11;
			}
		}

		& > .btn {
			width: calc(828px - 36px * 2);
			height: 80px;
			background: @themeColor;
			border-radius: @border-radius;
			position: fixed;
			left: 50%;
			bottom: 80px;
			transform: translateX(-50%);
			z-index: 21;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 400;
			font-size: 30px;
			color: #ffffff;
			line-height: 1;

			.moreIcon {
				width: 22px;
				height: 12px;
				display: block;
				transition: all 0.5s;
				transform: rotate(90deg);
			}
		}
	}

	& > .pdf {
		padding: 0 36px;
		// margin-bottom: 220px;
		margin-bottom: 80px;
		display: block;
		overflow: hidden;
		position: relative;

		&.show {
			&::after {
				content: '点击获取产品彩页';
				display: block;
				font-size: 32px;
				color: @themeColor;
				line-height: 1;
				text-align: center;
				font-weight: bold;
				text-decoration: underline;
				margin-top: 20px;
			}
		}

		img {
			width: 100%;
			height: auto;
			object-fit: cover;
			display: block;
			border-radius: @border-radius;
		}
	}
}
</style>